/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './app/routes/__root'
import { Route as IndexRouteImport } from './app/routes/index'
import { Route as DiceRouteImport } from './app/routes/dice'
import { Route as StatusRouteImport } from './app/routes/status'
import { Route as CampaignsNewRouteImport } from './app/routes/campaigns/new'
import { Route as CharactersIndexRouteImport } from './app/routes/characters/index'
import { Route as CharactersNewRouteImport } from './app/routes/characters/new'
import { Route as DevblogIndexRouteImport } from './app/routes/devblog/index'
import { Route as DevblogSlugRouteImport } from './app/routes/devblog/$slug'
import { Route as DevblogAdminRouteImport } from './app/routes/devblog/admin'
import { Route as UserAdminRouteImport } from './app/routes/user/admin'
import { Route as UserProfileRouteImport } from './app/routes/user/profile'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const DiceRoute = DiceRouteImport.update({
  id: '/dice',
  path: '/dice',
  getParentRoute: () => rootRouteImport,
} as any)
const StatusRoute = StatusRouteImport.update({
  id: '/status',
  path: '/status',
  getParentRoute: () => rootRouteImport,
} as any)
const CampaignsNewRoute = CampaignsNewRouteImport.update({
  id: '/campaigns/new',
  path: '/campaigns/new',
  getParentRoute: () => rootRouteImport,
} as any)
const CharactersIndexRoute = CharactersIndexRouteImport.update({
  id: '/characters/',
  path: '/characters/',
  getParentRoute: () => rootRouteImport,
} as any)
const CharactersNewRoute = CharactersNewRouteImport.update({
  id: '/characters/new',
  path: '/characters/new',
  getParentRoute: () => rootRouteImport,
} as any)
const DevblogIndexRoute = DevblogIndexRouteImport.update({
  id: '/devblog/',
  path: '/devblog/',
  getParentRoute: () => rootRouteImport,
} as any)
const DevblogSlugRoute = DevblogSlugRouteImport.update({
  id: '/devblog/$slug',
  path: '/devblog/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const DevblogAdminRoute = DevblogAdminRouteImport.update({
  id: '/devblog/admin',
  path: '/devblog/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const UserAdminRoute = UserAdminRouteImport.update({
  id: '/user/admin',
  path: '/user/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const UserProfileRoute = UserProfileRouteImport.update({
  id: '/user/profile',
  path: '/user/profile',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/dice': typeof DiceRoute
  '/status': typeof StatusRoute
  '/campaigns/new': typeof CampaignsNewRoute
  '/characters/new': typeof CharactersNewRoute
  '/devblog/$slug': typeof DevblogSlugRoute
  '/devblog/admin': typeof DevblogAdminRoute
  '/user/admin': typeof UserAdminRoute
  '/user/profile': typeof UserProfileRoute
  '/characters/': typeof CharactersIndexRoute
  '/devblog/': typeof DevblogIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/dice': typeof DiceRoute
  '/status': typeof StatusRoute
  '/campaigns/new': typeof CampaignsNewRoute
  '/characters/new': typeof CharactersNewRoute
  '/devblog/$slug': typeof DevblogSlugRoute
  '/devblog/admin': typeof DevblogAdminRoute
  '/user/admin': typeof UserAdminRoute
  '/user/profile': typeof UserProfileRoute
  '/characters': typeof CharactersIndexRoute
  '/devblog': typeof DevblogIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/dice': typeof DiceRoute
  '/status': typeof StatusRoute
  '/campaigns/new': typeof CampaignsNewRoute
  '/characters/new': typeof CharactersNewRoute
  '/devblog/$slug': typeof DevblogSlugRoute
  '/devblog/admin': typeof DevblogAdminRoute
  '/user/admin': typeof UserAdminRoute
  '/user/profile': typeof UserProfileRoute
  '/characters/': typeof CharactersIndexRoute
  '/devblog/': typeof DevblogIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/dice'
    | '/status'
    | '/campaigns/new'
    | '/characters/new'
    | '/devblog/$slug'
    | '/devblog/admin'
    | '/user/admin'
    | '/user/profile'
    | '/characters/'
    | '/devblog/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/dice'
    | '/status'
    | '/campaigns/new'
    | '/characters/new'
    | '/devblog/$slug'
    | '/devblog/admin'
    | '/user/admin'
    | '/user/profile'
    | '/characters'
    | '/devblog'
  id:
    | '__root__'
    | '/'
    | '/dice'
    | '/status'
    | '/campaigns/new'
    | '/characters/new'
    | '/devblog/$slug'
    | '/devblog/admin'
    | '/user/admin'
    | '/user/profile'
    | '/characters/'
    | '/devblog/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  DiceRoute: typeof DiceRoute
  StatusRoute: typeof StatusRoute
  CampaignsNewRoute: typeof CampaignsNewRoute
  CharactersNewRoute: typeof CharactersNewRoute
  DevblogSlugRoute: typeof DevblogSlugRoute
  DevblogAdminRoute: typeof DevblogAdminRoute
  UserAdminRoute: typeof UserAdminRoute
  UserProfileRoute: typeof UserProfileRoute
  CharactersIndexRoute: typeof CharactersIndexRoute
  DevblogIndexRoute: typeof DevblogIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dice': {
      id: '/dice'
      path: '/dice'
      fullPath: '/dice'
      preLoaderRoute: typeof DiceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/status': {
      id: '/status'
      path: '/status'
      fullPath: '/status'
      preLoaderRoute: typeof StatusRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/campaigns/new': {
      id: '/campaigns/new'
      path: '/campaigns/new'
      fullPath: '/campaigns/new'
      preLoaderRoute: typeof CampaignsNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/characters/': {
      id: '/characters/'
      path: '/characters'
      fullPath: '/characters/'
      preLoaderRoute: typeof CharactersIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/characters/new': {
      id: '/characters/new'
      path: '/characters/new'
      fullPath: '/characters/new'
      preLoaderRoute: typeof CharactersNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/devblog/': {
      id: '/devblog/'
      path: '/devblog'
      fullPath: '/devblog/'
      preLoaderRoute: typeof DevblogIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/devblog/$slug': {
      id: '/devblog/$slug'
      path: '/devblog/$slug'
      fullPath: '/devblog/$slug'
      preLoaderRoute: typeof DevblogSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/devblog/admin': {
      id: '/devblog/admin'
      path: '/devblog/admin'
      fullPath: '/devblog/admin'
      preLoaderRoute: typeof DevblogAdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/user/admin': {
      id: '/user/admin'
      path: '/user/admin'
      fullPath: '/user/admin'
      preLoaderRoute: typeof UserAdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/user/profile': {
      id: '/user/profile'
      path: '/user/profile'
      fullPath: '/user/profile'
      preLoaderRoute: typeof UserProfileRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  DiceRoute: DiceRoute,
  StatusRoute: StatusRoute,
  CampaignsNewRoute: CampaignsNewRoute,
  CharactersNewRoute: CharactersNewRoute,
  DevblogSlugRoute: DevblogSlugRoute,
  DevblogAdminRoute: DevblogAdminRoute,
  UserAdminRoute: UserAdminRoute,
  UserProfileRoute: UserProfileRoute,
  CharactersIndexRoute: CharactersIndexRoute,
  DevblogIndexRoute: DevblogIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
